export function Spacer(props: any) {
  return <div style={{ width: "100%", height: props.size }} />;
}
